import script from "./SmallCheckItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallCheckItem.vue?vue&type=script&setup=true&lang=js"

import "./SmallCheckItem.vue?vue&type=style&index=0&id=0f1c2d3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1c2d3c"]])

export default __exports__